import script from "./ReserveView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReserveView.vue?vue&type=script&setup=true&lang=js"

import "./ReserveView.vue?vue&type=style&index=0&id=a71fa45a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a71fa45a"]])

export default __exports__